import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import React, { useRef } from 'react';
import { Select } from '../../../ui/Select';
import { RangeFilter } from '../../../ui/RangeFilter';
import { BUILDING_TYPE_ID } from '../../../../utils/helpers/constants';
import { getRangeFilterValue } from '../../../../utils/helpers/getRangeFilterValue';
import { FilterFieldProps, SelectRefType } from '../types';
import { actionButtonStyles, RangeFilterWrapper } from '../styled';
import { ModalFooter } from '../../../ui/Modal/ModalFooter';
import useScreenSize from '../../../../hooks/useScreenSize';
import { useFilterChangeSubmit } from '../../../../hooks/useFilterChangeSubmit';
import { getBasedDataStatValueInFilters } from '../../../../utils/helpers/common';

export const AreaFilter: React.FC<FilterFieldProps> = ({
  submitOnChange = false,
  isPashaLanding
}) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();
  const { isSmall } = useScreenSize();
  const selectRef = useRef<SelectRefType>(null);
  const basedDataStat = getBasedDataStatValueInFilters(isPashaLanding);

  const fromValue = values.area_from;
  const toValue = values.area_to;

  const { handleClose } = useFilterChangeSubmit(
    fromValue,
    toValue,
    submitOnChange
  );

  const units =
    values.category_id === BUILDING_TYPE_ID.AREA
      ? t('search.form.units.acres')
      : t('search.form.units.metres');

  const resetButtonIsDisabled = !fromValue && !toValue;

  const squarePlaceholder = `${t('search.form.area')} ${units}`;
  const selectedValue = getRangeFilterValue({ fromValue, toValue, units, t });

  const onReset = () => {
    change('area_from', '');
    change('area_to', '');
  };

  const onSubmit = () => {
    if (selectRef.current) {
      selectRef.current?.closePopover();
    }
    handleClose();
  };

  return (
    <Select
      ref={selectRef}
      placeholder={squarePlaceholder}
      value={selectedValue}
      cypress={`${basedDataStat}-area-filter`}
      width={300}
      onClose={handleClose}
      modalTitle={squarePlaceholder}
      modalCypress="filter-modal"
    >
      <RangeFilterWrapper>
        <RangeFilter
          minId={`${basedDataStat}-form-area-from`}
          minName="area_from"
          maxName="area_to"
          maxId={`${basedDataStat}-form-area-to`}
        />
      </RangeFilterWrapper>
      {isSmall && (
        <ModalFooter
          resetIsDisabled={resetButtonIsDisabled}
          onReset={onReset}
          onConfirm={onSubmit}
          resetText={t('common.reset')}
          confirmText={t('common.apply')}
          confirmCypress="apply-btn"
          resetCypress="reset-btn"
          styles={actionButtonStyles}
        />
      )}
    </Select>
  );
};
